import { aboutData } from '@/mocks/about';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  const aboutJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于注册送彩金',
    description: aboutData.brandIntro,
    url: 'https://www.example.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '注册送彩金',
      url: 'https://www.example.com',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(aboutJsonLd)}</script>
      <ScrollToTop />
      <Navbar />
      <main className="min-h-screen pt-16">
        <section className="relative w-full h-[320px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20Chinese%20red%20and%20gold%20abstract%20geometric%20background%20with%20soft%20flowing%20patterns%2C%20elegant%20professional%20corporate%20atmosphere%2C%20luxurious%20texture%2C%20warm%20lighting&width=1920&height=400&seq=about-hero-2026&orientation=landscape"
              alt="关于我们"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/55"></div>
          </div>
          <div className="relative z-10 text-center px-4">
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-3">
              关于我们
            </h1>
            <p className="text-foreground-200 text-sm md:text-base max-w-lg mx-auto">
              了解注册送彩金的品牌故事与发展历程
            </p>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-50">
          <div className="max-w-[900px] mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', path: '/' },
                { label: '关于我们' },
              ]}
            />

            <div className="mt-8">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">
                品牌介绍
              </h2>
              <p className="text-foreground-600 text-base leading-relaxed mb-5">
                {aboutData.brandIntro}
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-8">
                <div className="bg-background-100 border border-background-200/70 rounded-xl p-6">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4">
                    <i className="ri-flag-line text-lg"></i>
                  </div>
                  <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">
                    我们的使命
                  </h3>
                  <p className="text-foreground-500 text-sm leading-relaxed">
                    {aboutData.mission}
                  </p>
                </div>
                <div className="bg-background-100 border border-background-200/70 rounded-xl p-6">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4">
                    <i className="ri-eye-line text-lg"></i>
                  </div>
                  <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">
                    我们的愿景
                  </h3>
                  <p className="text-foreground-500 text-sm leading-relaxed">
                    {aboutData.vision}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-18 bg-background-100">
          <div className="max-w-[900px] mx-auto px-4 md:px-6">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-8 text-center">
              发展历程
            </h2>
            <div className="relative">
              <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-primary-200 -translate-x-1/2 hidden md:block"></div>
              <div className="flex flex-col gap-6">
                {aboutData.history.map((item, index) => (
                  <div
                    key={item.year}
                    className={`flex flex-col md:flex-row gap-4 md:gap-8 ${
                      index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                    }`}
                  >
                    <div className={`flex-1 ${index % 2 === 0 ? 'md:text-right' : 'md:text-left'}`}>
                      <div className="bg-background-50 border border-background-200/70 rounded-xl p-5">
                        <span className="inline-block px-3 py-1 bg-primary-500 text-background-50 rounded-full text-sm font-bold mb-2">
                          {item.year}
                        </span>
                        <p className="text-foreground-600 text-sm leading-relaxed">
                          {item.event}
                        </p>
                      </div>
                    </div>
                    <div className="hidden md:flex items-center justify-center w-8 flex-shrink-0">
                      <div className="w-4 h-4 rounded-full bg-primary-500 border-4 border-background-50"></div>
                    </div>
                    <div className="flex-1 hidden md:block"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-18 bg-background-50">
          <div className="max-w-[900px] mx-auto px-4 md:px-6">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-8 text-center">
              用户口碑
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {aboutData.reputation.map((review) => (
                <div
                  key={review.id}
                  className="bg-background-50 border border-background-200/70 rounded-xl p-5"
                >
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 font-bold text-sm">
                      {review.avatar}
                    </div>
                    <div>
                      <div className="font-medium text-foreground-900 text-sm">
                        {review.name}
                      </div>
                      <div className="flex items-center gap-0.5">
                        {Array.from({ length: 5 }, (_, i) => (
                          <i
                            key={i}
                            className={`text-xs ${
                              i < review.rating
                                ? 'ri-star-fill text-accent-500'
                                : 'ri-star-line text-foreground-300'
                            }`}
                          ></i>
                        ))}
                      </div>
                    </div>
                  </div>
                  <p className="text-foreground-500 text-xs leading-relaxed mb-3">
                    "{review.comment}"
                  </p>
                  <span className="text-foreground-400 text-xs">{review.date}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-18 bg-background-100">
          <div className="max-w-[900px] mx-auto px-4 md:px-6">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-8 text-center">
              联系我们
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              <div className="bg-background-50 border border-background-200/70 rounded-xl p-5 flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                  <i className="ri-phone-line text-lg"></i>
                </div>
                <div>
                  <h4 className="font-heading text-base font-bold text-foreground-900 mb-1">
                    客服电话
                  </h4>
                  <p className="text-foreground-600 text-sm">{aboutData.contactInfo.phone}</p>
                </div>
              </div>
              <div className="bg-background-50 border border-background-200/70 rounded-xl p-5 flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <div>
                  <h4 className="font-heading text-base font-bold text-foreground-900 mb-1">
                    电子邮箱
                  </h4>
                  <p className="text-foreground-600 text-sm">{aboutData.contactInfo.email}</p>
                </div>
              </div>
              <div className="bg-background-50 border border-background-200/70 rounded-xl p-5 flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                  <i className="ri-wechat-line text-lg"></i>
                </div>
                <div>
                  <h4 className="font-heading text-base font-bold text-foreground-900 mb-1">
                    微信客服
                  </h4>
                  <p className="text-foreground-600 text-sm">{aboutData.contactInfo.wechat}</p>
                </div>
              </div>
              <div className="bg-background-50 border border-background-200/70 rounded-xl p-5 flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                  <i className="ri-qq-line text-lg"></i>
                </div>
                <div>
                  <h4 className="font-heading text-base font-bold text-foreground-900 mb-1">
                    QQ客服
                  </h4>
                  <p className="text-foreground-600 text-sm">{aboutData.contactInfo.qq}</p>
                </div>
              </div>
              <div className="bg-background-50 border border-background-200/70 rounded-xl p-5 flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                  <i className="ri-map-pin-line text-lg"></i>
                </div>
                <div>
                  <h4 className="font-heading text-base font-bold text-foreground-900 mb-1">
                    公司地址
                  </h4>
                  <p className="text-foreground-600 text-sm">{aboutData.contactInfo.address}</p>
                </div>
              </div>
              <div className="bg-background-50 border border-background-200/70 rounded-xl p-5 flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                  <i className="ri-time-line text-lg"></i>
                </div>
                <div>
                  <h4 className="font-heading text-base font-bold text-foreground-900 mb-1">
                    工作时间
                  </h4>
                  <p className="text-foreground-600 text-sm">{aboutData.contactInfo.workingHours}</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 bg-primary-500">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
              准备好开始了吗？
            </h2>
            <p className="text-primary-100 text-sm mb-6 max-w-lg mx-auto">
              立即注册即可免费领取专属彩金，加入超过128,000位玩家的行列
            </p>
            <a
              href="#"
              className="inline-flex items-center gap-2 px-8 py-3 bg-background-50 text-primary-600 rounded-xl text-base font-bold hover:bg-background-100 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              立即注册领取
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}